import { ActionIcon, Group } from '@mantine/core';
import {
  IconArrowLeft,
  IconDotsCircleHorizontal,
  IconInfoSquareRounded,
  IconStack2,
  IconTimeline,
  IconX,
} from '@tabler/icons';
import { FC, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNavigationItem } from '../../../Organismns/Navigation/NavigationItemHook';
import { ResourceDetailsContext } from '../../../Service/Context/ResourceDetailsContext';
import { ResourceType } from '../../../Types/ResourceT';
import ActionIconWithText from './ActionIconWithText';

interface HandlersProps {
  toggleAsideBar: () => void;
  asideBarOpen: boolean;
}

const ResourceDetailsPageFooter: FC<HandlersProps> = ({ toggleAsideBar, asideBarOpen }) => {
  const navigate = useNavigate();
  const { resourceId, resource } = useContext(ResourceDetailsContext);
  const stocksPathActive = useNavigationItem(`/resources/${resourceId}/stock-intervals`);

  // eslint-disable-next-line no-underscore-dangle
  const _navigate = (pathname: string) => {
    if (asideBarOpen) {
      toggleAsideBar();
    }
    navigate(pathname);
  };

  return (
    <Group px="xl" pt={5} sx={{ justifyContent: 'space-between' }}>
      <ActionIcon onClick={() => navigate('/resources/all')}>
        <IconArrowLeft />
      </ActionIcon>
      <ActionIconWithText
        label="Details"
        active={useNavigationItem(`/resources/${resourceId}/details`)}
        onClick={() => _navigate(`/resources/${resourceId}/details`)}
      >
        <IconInfoSquareRounded />
      </ActionIconWithText>
      <ActionIconWithText
        isVisible={resource?.type !== ResourceType.KIT}
        label="Bestand"
        active={stocksPathActive}
        onClick={() => _navigate(`/resources/${resourceId}/stock-intervals`)}
      >
        <IconStack2 />
      </ActionIconWithText>
      <ActionIconWithText
        label="Planung"
        active={useNavigationItem(`/resources/${resourceId}/planning`)}
        onClick={() => _navigate(`/resources/${resourceId}/planning`)}
      >
        <IconTimeline />
      </ActionIconWithText>
      <ActionIconWithText label={asideBarOpen ? '' : 'Mehr'} onClick={toggleAsideBar}>
        {asideBarOpen ? <IconX /> : <IconDotsCircleHorizontal />}
      </ActionIconWithText>
    </Group>
  );
};

export default ResourceDetailsPageFooter;
